import type { ReactNode } from 'react';

import { Button, useMainFormContext } from '@/_components';

import { type THeaderWithBack } from './left-header-with-back';
import { StickyPageHeader } from './sticky-page-header';

type Props = THeaderWithBack & {
  isModal?: boolean;
  doneButton?: {
    hide?: boolean;
    label?: string;
    disabled?: boolean;
  };
  rightSlot?: ReactNode;
};

export function StickyPageHeaderWithDone({ isModal, routes, title, backLink, doneButton, rightSlot }: Props) {
  const { isSubmitting } = useMainFormContext();

  return (
    <StickyPageHeader isModal={isModal} title={title} routes={isModal ? undefined : routes} backLink={backLink}>
      <div className="flex items-center gap-2">
        {rightSlot}
        {!doneButton?.hide && (
          <Button type="submit" size="sm" disabled={doneButton?.disabled} showLoader={isSubmitting}>
            {doneButton?.label ?? 'Done'}
          </Button>
        )}
      </div>
    </StickyPageHeader>
  );
}
